import paymentService from "../../../../services/payment-service";
import { getOrderById } from "../../../../redux/slices/orders-slice";
import { toast } from "react-toastify";
import { OrderModel } from "../../../shared/models/order/order-item.model";
import { NavigateFunction } from "react-router-dom";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { MessageSections } from "../../../components/message/message";
import { getMessage } from "../../../shared/helper-functions";
import balanceService from "../../../../services/balance-service";
import { getCurrentBalance } from "../../../../redux/slices/balance-slice";

export async function onPayNow(
  order: OrderModel,
  navigate: NavigateFunction,
  dispatch: ThunkDispatch<any, any, any>,
  messageCache: any,
  languageId: number,
  setPopupOpened?: (isSucceeded: boolean) => void,
  shouldPay?: number,
) {
  
  if (order.orderId) {
    try {
      await paymentService.payNow([order.orderId]).then((payload) => {
        if (payload && payload.data && payload.data.modifiedCount > 0) {
          if (setPopupOpened) {
            setPopupOpened(true);
            dispatch(getCurrentBalance());
            dispatch(getOrderById(order.orderId));
          }
        }
      });
    } catch (error) {
      const toastMessage = getMessage('insufficient_funds', MessageSections.ORDERS, messageCache, languageId);
      const type = "warn";
      initToast(toastMessage, type);
      setTimeout(() => navigate(`../../user/balance?balanceLeft=${shouldPay}`), 2000);
    }
  }
}

function initToast(message: string, type: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  toast[type](message, {
    position: "top-right",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
